module.exports = __webpack_public_path__ + "img/slide_2.117fc954.webp";